<template>
  <div>
    <a
      class="calendar"
      target="_blank"
      :href="`${base_url}/videos/ics/${video.slug}`"
    >
      <BaseIcon :name="['far', 'calendar-plus']" />
      Outlook
    </a>
  </div>
</template>

<script>
export default {
  props: {
    video: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      base_url: process.env.VUE_APP_API_BASE_URL,
    }
  },
}
</script>
